import styled, { css } from "styled-components";

import Props from "./props";

const Fab = styled.button<Props>`
    margin: 0;
    transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0px 3px 1px -2px ${props => props.theme.colors.black(0.2)}, 0px 2px 2px 0px ${props => props.theme.colors.black(0.14)},
        0px 1px 5px 0px ${props => props.theme.colors.black(0.12)};
    outline: none;
    cursor: pointer;
    border: none;
    padding: 0;
    border-radius: 100%;
    font-weight: 300;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        box-shadow: 0px 2px 4px -1px ${props => props.theme.colors.black(0.2)}, 0px 4px 5px 0px ${props => props.theme.colors.black(0.14)},
            0px 1px 10px 0px ${props => props.theme.colors.black(0.12)};
    }
    ${({ active, mini }) => {
        if (active && !mini) {
            return css`
                transform: rotateZ(-225deg);
            `;
        } else if (mini && !active) {
            return css`
                opacity: 0;
                transform: scaleX(0.3) scaleY(0.3) translateY(8rem) translateX(-50%);
            `;
        } else if (mini && active) {
            return css`
                opacity: 1;
                transform: scaleX(1) scaleY(1) translateY(0rem) translateX(-50%);
            `;
        }
    }}
    ${({ mini }) =>
        mini
            ? css`
                  position: relative;
                  left: 50%;
                  width: 2.5rem;
                  height: 2.5rem;
                  line-height: 2.5rem;
                  font-size: 1.5rem;
                  z-index: 1;
                  margin-bottom: 0.6rem;
              `
            : css`
                  width: 3.5rem;
                  height: 3.5rem;
                  line-height: 3.5rem;
                  font-size: 2rem;
                  z-index: 2;
                  position: fixed;
                  bottom: 1rem;
                  right: 1rem;
              `}
    ${({ primary }) =>
        primary
            ? css`
                  background-color: ${props => props.theme.colors.primary(1)};
                  color: ${props => props.theme.colors.primaryInvert(1)};
              `
            : css`
                  background-color: ${props => props.theme.colors.light(1)};
                  color: ${props => props.theme.colors.lightInvert(1)};
              `}
    @media print {
        display: none;
    }
`;

export default Fab;
